/* @flow weak */
import CurrentUser from 'auth/CurrentUser';
import JoinSignUpForm from './JoinSignUpForm.jsx';
import OrganizationProfile from 'entities/OrganizationProfile';
import PropTypes from 'prop-types';
import * as React from 'react';
import { Roles } from 'user/UserConstants';
import ToastActions from 'actions/ToastActions';
import UserActions from 'user/UserActions';
import errorLogger from 'utils/errorLogger';

import './styles/JoinOrganizationFormPanel.scss';

class JoinOrganizationFormPanel extends React.Component<$FlowFixMeProps> {
  static propTypes = {
    organization: PropTypes.instanceOf(OrganizationProfile).isRequired,
    defaultValues: PropTypes.object,
    role: PropTypes.oneOf([Roles.teacher, Roles.student, Roles.parent]).isRequired,
  };

  static contextTypes = {
    router: PropTypes.object.isRequired,
  };

  transitionToGroups = () => {
    this.context.router.push('/classes?origin=subscribed');
  };

  updateUserOrganization = () => {
    const onUserUpdateSuccess = () => {
      ToastActions.showSuccessToast('School joined');
      this.context.router.push('/landing');
    };

    const updateData = {
      organization_id: this.props.organization.id,
      role: CurrentUser.getUser().getRole() || this.props.role,
    };

    UserActions.update(updateData)
      .then(onUserUpdateSuccess)
      .catch(errorLogger('JoinOrganizationFormPanel updateUserOrganization failed'));
  };

  render() {
    return (
      <div className="JoinOrganizationFormPanel">
        <JoinSignUpForm
          defaultValues={this.props.defaultValues}
          onUserCreate={this.updateUserOrganization}
        />
      </div>
    );
  }
}

export default JoinOrganizationFormPanel;
